import { FC } from 'react';
import { Checkbox, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { ExpLess, ExpMore, IconWrapper } from '@styles/Admin-tools/Roles/RoleModalStyles';

interface ISelectableListItemProps {
  checked?: boolean;
  text: string;
  open?: boolean;

  onSelectionChange?(): void;

  onToggle?(): void;
}

export const SelectableListItem: FC<ISelectableListItemProps> = ({
  checked,
  text,
  open,
  onSelectionChange,
  onToggle,
}) => {
  const onCheckboxClick = (event: React.MouseEvent<HTMLElement>) => {
    onSelectionChange?.();
    event.stopPropagation();
  };

  return (
    <ListItem dense disablePadding>
      <ListItemButton dense sx={{ p: '0 5px' }} onClick={onToggle}>
        <IconWrapper>{open !== undefined ? open ? <ExpLess /> : <ExpMore /> : null}</IconWrapper>

        {onSelectionChange && (
          <IconWrapper onClick={onCheckboxClick}>
            <Checkbox disableRipple edge="start" checked={checked} tabIndex={-1} />
          </IconWrapper>
        )}

        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  );
};
